<!--Banner part code-->
<div class="uk-child-width-1-1@s" uk-grid>
    <div>
        <div class="uk-background-cover uk-height-large uk-panel  uk-flex-center uk-flex-middle"
            style="background-image: url(../../assets/ourvaluebanner.png);">
            <div class="uk-section uk-light">
                <div class="uk-container-small uk-width-2xlarge" style="padding-top: 60px;">

                    <div><h1 class="uk-text-bold uk-padding-large uk-padding-remove-vertical" style="margin-bottom: 10px;">
                        Our Collective Benefits</h1>
                </div>
                <div>
                    <p class="uk-padding-large uk-text-left  uk-padding-remove-vertical" style="font-size: 20px;">We specialize in developing Web and Mobile Applications, Digital Marketing to create your life more manageable.</p>
                </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Banner part code ends-->
<div class="uk-section uk-padding">
    <div class="uk-container">

        <br>
        <p class="uk-text-medium uk-text-justify">WebSoulLabs was established to give a broad variety of IT 
            services and to give a better interface using the most advanced technologies. We strive to succeed
             great extents as an organized and developing Software and Web Development company giving a quality 
             of services in software development, analysis, testing, web design, digital marketing, E-commerce, 
             secure payment integration with the E-commerce websites, and also good client support. We try at growing our business across broader fields by
             connecting hands with our national clients in India. We have a legacy of working hand-in-hand 
             with our clients at every stage of the project development means to connect the interests of
              the client and our professional expertise to give the best and quality outcomes.


        </p>

    </div>
</div>
<div class="uk-container">
    <img class="uk-align-center" src="assets/quote.svg" width="100" height="100" alt="">
    <h2 class="uk-text-center" style="font-weight:600">“We pull up with all our clients and professionals to share and
         explore more innovative thoughts and to implement for the mutual growth and advantage of both”</h2>
    <p class="uk-text-medium uk-text-center">WebSoulLabs applies a solid resolution and create a list of
         objectives to be accomplished and encourages innovative thoughts from the professionals as well as 
         clients for the improvement of the project being created and also to get the achievement. 
         At WebSoulLabs, we always careful to automate and blend latest, innovative thoughts into the 
         reaches of our everyday life.</p>
</div>
<br><br>
<div class="uk-container">
    <h1 class="uk-text-center" style="font-weight:600">WebSoulLabs Ideologies </h1>

    <p class="uk-text-large uk-text-center"> Websoullabs craves and cares about </p>
    <br>
    <div class="uk-child-width-1-3@s uk-grid-match" uk-grid>
        <div class="uk-animation-toggle" tabindex="0">
            <div
                class="uk-card uk-card-default uk-text-center uk-card-body uk-animation-scale-up uk-transform-origin-bottom-center">
                <img class="uk-border-pill uk-align-center" src="assets/expert.png" width="70" height="70" alt="">
                <h3>Management and Modernization</h3>

            </div>
        </div>
        <div class="uk-animation-toggle" tabindex="0">
            <div
                class="uk-card uk-card-default uk-text-center uk-card-body uk-animation-scale-up uk-transform-origin-bottom-center">
                <img class="uk-border-pill uk-align-center" src="assets/rescue.jpg" width="70" height="70" alt="">
                <h3>Knowledge-Driven Company </h3>

            </div>
        </div>
        <div class="uk-animation-toggle" tabindex="0">
            <div
                class="uk-card uk-card-default uk-text-center uk-card-body uk-animation-scale-up uk-transform-origin-bottom-center">
                <img class="uk-border-pill uk-align-center" src="assets/seo.png" width="70" height="70" alt="">
                <h3>Customer-Key Tactics</h3>

            </div>
        </div>
        <div class="uk-animation-toggle" tabindex="0">
            <div
                class="uk-card uk-card-default uk-text-center uk-card-body uk-animation-scale-up uk-transform-origin-bottom-center">
                <img class="uk-border-pill uk-align-center" src="assets/shake.png" width="70" height="70" alt="">
                <h3>Commitment to Profession</h3>

            </div>
        </div>
        <div class="uk-animation-toggle" tabindex="0">
            <div
                class="uk-card uk-card-default uk-text-center uk-card-body uk-animation-scale-up uk-transform-origin-bottom-center">
                <img class="uk-border-pill uk-align-center" src="assets/integrity.webp" width="60" height="60" alt="">
                <h3>Honesty, Loyalty, and Transparency</h3>

            </div>
        </div>
        <div class="uk-animation-toggle" tabindex="0">
            <div
                class="uk-card uk-card-default uk-text-center uk-card-body uk-animation-scale-up uk-transform-origin-bottom-center">
                <img class="uk-border-pill uk-align-center" src="assets/excellence.jpg" width="65" height="65" alt="">
                <h3>Chase of Excellence</h3>

            </div>
        </div>
        <div class="uk-animation-toggle" tabindex="0">
            <div
                class="uk-card uk-card-default uk-text-center uk-card-body uk-animation-scale-up uk-transform-origin-bottom-center">
                <img class="uk-border-pill uk-align-center" src="assets/qd.jpg" width="70" height="70" alt="">
                <h3>Quality Services</h3>

            </div>
        </div>
        <div class="uk-animation-toggle" tabindex="0">
            <div
                class="uk-card uk-card-default uk-text-center uk-card-body uk-animation-scale-up uk-transform-origin-bottom-center">
                <img class="uk-border-pill uk-align-center" src="assets/collabo.jpg" width="70" height="70" alt="">
                <h3>Cultural Collaboration</h3>

            </div>
        </div>
        <div class="uk-animation-toggle" tabindex="0">
            <div
                class="uk-card uk-card-default uk-text-center uk-card-body uk-animation-scale-up uk-transform-origin-bottom-center">
                <img class="uk-border-pill uk-align-center" src="assets/delivery.png" width="70" height="70" alt="">
                <h3>On-schedule Delivery</h3>

            </div>
        </div>

    </div>
</div>
<br>
<br>
<br>